module.exports = "<div class=\"loading-overlay\" *ngIf=\"loading && !somethingToSetup\">\n    <mat-spinner></mat-spinner>\n</div>\n<div class=\"loading-overlay\" *ngIf=\"loading && somethingToSetup\">\n    <div class=\"loading-overlay__message\">{{ appSettingInfo.message }}</div>\n    <mat-progress-bar [value]=\"appSettingInfo.progress\"></mat-progress-bar>\n</div>\n<router-outlet *ngIf=\"!somethingToSetup\"></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main